<template>
  <div class="enterprise-main">
    <Card :padding="10" shadow title="查询条件" class="bt-card">
        <div class="search-con search-con-top">
            <Select v-model="etype" class="bt-input" placeholder="请选择分类" clearable style="width: 220px; margin-right: 8px;">
                <Option v-for="item in typeList" :key="item" :value="item">{{item}}</Option>
            </Select>
            <Input v-model.trim="name" class="bt-input" placeholder="输入企业名称或表内字段" clearable style="width: 220px; margin-right: 8px;"/>
            <Button type="primary" @click="search">搜索</Button>&nbsp;&nbsp;
            <Button type="primary" @click="addEnterprise">新增</Button>
        </div>
    </Card>

    <Card :padding="10" title="企业列表" shadow>
      <Table :columns="columns" border :data="list" stripe></Table>
      <Page :show-total="true" :total="total" :current="pn" :page-size="ps" class-name="bt-page" @on-change="changePage"/>
    </Card>

    <Modal
        v-model="modal"
        :title="!editEnterprise.id ? '新增企业' : '编辑企业'"
        :width="640"
        @on-visible-change="resetForm">
        <Form ref="editEnterprise" :model="editEnterprise" :label-width="120">
            <FormItem label="分类" prop="etype" :rules="{required: true, message: '请选择分类'}">
                <Select v-model="editEnterprise.etype" placeholder="请选择企业分类">
                    <Option v-for="item in typeList" :key="item" :value="item">{{item}}</Option>
                </Select>
            </FormItem>
            <FormItem label="企业名称" prop="name" :rules="{required: true, message: '请输入企业名称', max: 100}">
                <Input v-model="editEnterprise.name" placeholder="请输入企业名称"></Input>
            </FormItem>
            <FormItem label="所属街道/园区" prop="streetPark" :rules="{required: false, max: 255, message: '长度不能超过255个字'}">
                <Input v-model="editEnterprise.streetPark" placeholder="请输入所属街道 / 园区"></Input>
            </FormItem>
            <FormItem v-if="showBatchNo" label="批次" prop="batchNo" :rules="{required: false, max: 100, message: '长度不能超过100个字'}">
                <Input v-model="editEnterprise.batchNo" placeholder="请输入批次（如：第一批）"></Input>
            </FormItem>
            <FormItem v-if="showMainField" label="主营领域" prop="mainField" :rules="{required: false, max: 500, message: '长度不能超过500个字'}">
                <Input v-model="editEnterprise.mainField" placeholder="请输入主营领域"></Input>
            </FormItem>
            <FormItem v-if="showCertTime" label="认定时间" prop="certTime" :rules="{required: false, max: 500, message: '长度不能超过500个字'}">
                <Input type="textarea" :rows="3" v-model="editEnterprise.certTime" placeholder="请输入认定时间"></Input>
            </FormItem>
            <FormItem label="信用代码" prop="code" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
                <Input v-model="editEnterprise.code" placeholder="统一社会信用代码"></Input>
            </FormItem>
            <FormItem label="注册地址" prop="registerAddress" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
                <Input v-model="editEnterprise.registerAddress" placeholder="企业注册地址"></Input>
            </FormItem>
            <FormItem label="办公地址" prop="address" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
                <Input v-model="editEnterprise.address" placeholder="企业实际办公地址"></Input>
            </FormItem>
            <FormItem label="行业领域" prop="industry" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
                <AutoComplete
                    v-model="editEnterprise.industry"
                    :data="industryList"
                    placeholder="行业领域" />
            </FormItem>
            <FormItem label="企业资质" prop="qualification" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
                <AutoComplete
                    v-model="editEnterprise.qualification"
                    :data="qList"
                    placeholder="企业资质" />
            </FormItem>
            <FormItem label="承担项目" prop="undertakeProject" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
                <Input v-model="editEnterprise.undertakeProject" placeholder="XXX省级项目、XXX市级项目"></Input>
            </FormItem>
            <FormItem label="营业收入" prop="income2021" :rules="{required: false}">
                <Select v-model="editEnterprise.income2021" placeholder="营业收入" clearable>
                    <Option v-for="item in feeList" :key="item" :value="item">{{item}}</Option>
                </Select>
            </FormItem>
            <FormItem label="研发投入" prop="putin2021" :rules="{required: false}">
                <Select v-model="editEnterprise.putin2021" placeholder="研发投入" clearable>
                    <Option v-for="item in feeList" :key="item" :value="item">{{item}}</Option>
                </Select>
            </FormItem>
            <FormItem label="核心产品简介" prop="productIntroduce" :rules="{required: false}">
                <editor v-model="editEnterprise.productIntroduce"></editor>
            </FormItem>
            <FormItem label="企业技术需求" prop="requirements" :rules="{required: false, message: '长度不能超过500个字', max: 500}">
                <Input type="textarea" v-model="editEnterprise.requirements" placeholder="企业技术需求"></Input>
            </FormItem>
            <FormItem label="联系人名字" prop="contactName" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
                <Input v-model="editEnterprise.contactName" placeholder="联系人名字"></Input>
            </FormItem>
            <FormItem label="联系人职位" prop="contactJob" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
                <Input v-model="editEnterprise.contactJob" placeholder="联系人职位"></Input>
            </FormItem>
            <FormItem label="联系人手机号" prop="contactPhone" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
                <Input v-model="editEnterprise.contactPhone" placeholder="联系人手机号"></Input>
            </FormItem>
            <FormItem label="缩略图" prop="thumbnail">
                <CustomUpload v-model="editEnterprise.thumbnail"></CustomUpload>
            </FormItem>
            <FormItem label="图片" prop="mainPic" :rules="{required: false}">
                <CustomUpload v-model="editEnterprise.mainPic"></CustomUpload>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" size="large" @click="modal=false">取消</Button>
            <Button type="primary" size="large" @click="handleEnterpriseSubmit">确定</Button>
        </div>
    </Modal>
    
    <Modal
        v-model="auditBackModal"
        title="审核打回">
        <Form ref="auditBackValue" :model="auditBackValue" :label-width="100">
            <FormItem label="原因" prop="reason" :rules="{required: true, message: '原因不能为空'}">
                <Input v-model.trim="auditBackValue.reason" placeholder="请输入原因"></Input>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" size="large" @click="auditBackModal=false">取消</Button>
            <Button type="primary" size="large" @click="handleAuditBackSubmit">确定</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import editor from '@/components/common/Editor';
const moment = require('moment');

export default {
  name: 'enterpriseMain',
  data() {
    return {
      currentUser: {},
      rs: [],
      roleList: [],
      showEditRole: false,
      name: '',
      etype: '',
      list: [],
      pn: 1,
      ps: 20,
      total: 1,
      columns: [{
        key: 'id',
        title: 'ID',
        width: 80,
        align: 'center'
      }, {
        key: 'etype',
        title: '分类',
        minWidth: 160,
        align: 'center'
      }, {
        key: 'name',
        title: '企业名称',
        minWidth: 220,
        align: 'center'
      }, {
        key: 'streetPark',
        title: '所属街道/园区',
        minWidth: 130,
        align: 'center',
        render: (h, { row }) => {
          return h('span', row.streetPark || row.sname || '-');
        }
      }, {
        key: 'batchNo',
        title: '批次',
        minWidth: 100,
        align: 'center',
        render: (h, { row }) => {
          return h('span', row.batchNo || '-');
        }
      }, {
        key: 'mainField',
        title: '主营领域',
        minWidth: 160,
        align: 'center',
        render: (h, { row }) => {
          return h('span', row.mainField || '-');
        }
      }, {
        key: 'certTime',
        title: '认定时间',
        minWidth: 180,
        align: 'center',
        render: (h, { row }) => {
          return h('div', { style: { whiteSpace: 'pre-line' } }, row.certTime || '-');
        }
      }, {
        key: 'status',
        title: '审核状态',
        width: 110,
        align: 'center',
        render: (h, { row, index }) => {
            if(row.status == 0){
                return h('Tag', {props: {color: 'default'}}, '待审核');
            }else if(row.status == 1){
                return h('Tag', {props: {color: 'primary'}}, '审核通过');
            }else {
                return h('Tag', {
                    props: {color: 'error'},
                    nativeOn: {
                        click: () => {
                            this.lookAuditBackReason(index);
                        }
                    }
                }, '审核失败');
            }
        }
      }, {
        key: 'createTime',
        title: '创建时间',
        width: 160,
        align: 'center',
        render: (h, params) => {
          return h('div', params.row.createTime ? moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-');
        }
      }, {
        key: 'option',
        title: '操作',
        width: 220,
        align: 'center',
        render: (h, { row, index }) => {
          let data = [];
          if(row.status != 1){
                data.push(h('Button', {
                    props: {type: 'info', size: 'small'},
                    style: {marginRight: '5px'},
                    on: {
                        click: () => {
                            this.handleEditEnterpriseStatus(index, 1);
                        }
                    },
                    directives: [{
                        name: 'permission',
                        value: 'enterprise:audit'
                    }]
                }, "审核通过"));
            }
            if(row.status != 2){
                data.push(h('Button', {
                    props: {type: 'error', size: 'small'},
                    style: {marginRight: '5px'},
                    on: {
                        click: () => {
                            this.handleEditEnterpriseStatus(index, 2);
                        }
                    },
                    directives: [{
                        name: 'permission',
                        value: 'enterprise:audit'
                    }]
                }, "审核打回"));
          }
          data.push(h('Button', {
            props: {type: 'success', size: 'small'},
            style: {marginRight: '5px'},
            on: {
              click: () => {
                this.handleEditEnterprise(index);
              }
            }
          }, "编辑"));
          return h('div', data);
        }
      }],
      auditBackModal: false,
      auditBackValue: {
         id: 0,
         status: 0,
         reason: ''
      },
      modal: false,
      editEnterprise: {
        etype: '科技型中小企业',
        name: '',
        streetPark: '',
        batchNo: '',
        mainField: '',
        certTime: ''
      },
      industryList: ["电子信息","生物与新医药","航空航天","新材料","高技术服务","新能源与节能","资源与环境","先进制造与自动化","其他"],
      qList: ["高新技术企业","江苏省工程技术研究中心"],
      feeList: ["100万元以下","100万元-500万元","500万元-1000万元","1000万元-1500万元","1500万元-2000万元","2000万元以上"],
      typeList: ['科技型中小企业', '高新技术企业', '规上企业', '瞪羚／独角兽及培育独角兽企业', '专精特新中小企业', '专精特新“小巨人”企业'],
    }
  },
  computed: {
    showBatchNo() {
      return this.editEnterprise.etype === '科技型中小企业';
    },
    showMainField() {
      return this.editEnterprise.etype === '规上企业';
    },
    showCertTime() {
      const t = this.editEnterprise.etype || '';
      return (
        t === '瞪羚／独角兽及培育独角兽企业' ||
        t === '瞪羚/独角兽及培育独角兽企业' ||
        t === '专精特新中小企业' ||
        t.indexOf('小巨人') !== -1
      );
    }
  },
  created() {
    this.queryList();
  },
  methods: {
    handleEnterpriseSubmit(){
        this.$refs['editEnterprise'].validate((valid) => {
            if(valid) {
                this.$http.post('/api/enterprise/save', this.editEnterprise).then(() => {
                    this.$Message.success('操作成功');
                    this.queryList();
                    this.modal = false;
                });
            }
        });
    },
    handleEditEnterprise(index){
        const row = Object.assign({}, this.list[index]);
        if (!row.streetPark && row.sname) {
            row.streetPark = row.sname;
        }
        this.editEnterprise = this.filterNullValue(row);
        this.modal = true;
    },
    addEnterprise(){
        this.editEnterprise = {
            etype: this.etype || '科技型中小企业',
            name: '',
            streetPark: '',
            batchNo: '',
            mainField: '',
            certTime: ''
        };
        this.modal = true;
    },
    filterNullValue(obj){
        for(let key in obj){
            if(key == 'sid'){
                continue;
            }
            if(obj[key] == null){
                obj[key] = '';
            }
        }
        return obj;
    },
    resetForm(show){
        if(!show) {
            this.$refs.editEnterprise.resetFields();
            this.editEnterprise.id = 0;
        }
    },
    edit(){
      this.$router.push({path:'/enterprise/addEnterprise'})
    },
    search(){
      this.pn = 1;
      this.queryList();
    },
    queryList() {
      this.$http.get('/api/enterprise/getEnterpriseList', {
        key: this.name,
        etype: this.etype,
        pn: this.pn,
        ps: this.ps
      }).then(data => {
        this.list = data.list;
        this.total = data.total;
      });
    },
    changePage(pn) {
      this.pn = pn;
      this.queryList();
    },
    openAuditBack(id, status){
        this.auditBackValue = {
            id: id,
            status: status,
            reason: ''
        };
        this.auditBackModal = true;
        this.$refs['auditBackValue'].resetFields();
    },
    handleAuditBackSubmit(){
        this.$refs['auditBackValue'].validate((valid) => {
            if(valid) {
                this.$http.post('api/enterprise/updateEnterpriseStatus', this.auditBackValue).then(()=>{
                    this.$Message.success("审核打回成功");
                    this.auditBackModal = false;
                    this.queryList();
                });
            }
        });
    },
    handleEditEnterpriseStatus(index, status){
        let enterprise = this.list[index];
        if(status == 1){
            this.$Modal.confirm({
                title: '审核操作',
                content: '确认审核成功吗？',
                onOk: () => {
                    this.$http.post('api/enterprise/updateEnterpriseStatus', {id: enterprise.id, status: status}).then(()=>{
                        this.$Message.success("审核成功");
                        this.queryList();
                    });
                }
            });
        }else if(status == 2){
            this.openAuditBack(enterprise.id, status);
        }else {
            this.$Message.error("无效状态");
        }
    },
    lookAuditBackReason(index){
        this.$http.post('api/admin/queryAuditLogReason', {itemId: this.list[index].id, itemType: 2}, false).then((data)=>{
            this.$Modal.error({
                title: '打回原因',
                content: data
            });
        });
    }
  },
  components: {editor}
}
</script>
